'use client';

import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "prefixCls", "children"];
import { memo } from 'react';
import FlexBasic from "../FlexBasic";
import { getPrefix } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Flexbox = /*#__PURE__*/memo(function (_ref) {
  var className = _ref.className,
    prefixCls = _ref.prefixCls,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(FlexBasic, _objectSpread(_objectSpread({}, props), {}, {
    internalClassName: "".concat(getPrefix(prefixCls), "-flexbox"),
    className: className,
    children: children
  }));
});
Flexbox.displayName = 'Flexbox';
export { Flexbox };